import styled from "styled-components";

export const SMaintenanceWarningLoginIcon = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;
